const {
    APP_TITLE,
    APP_ENVIRONMENT,
    APP_COMMIT_HASH,
    APP_VERSION,
    APP_PACKAGE_NAME,
    APP_REPOSITORY_URL,
    APP_ADMIN_URL,
    APP_API_DOMAIN,
} = import.meta.env;

export const appTitle = APP_TITLE; // not used
export const environment = APP_ENVIRONMENT; // not used
export const appCommitHash = APP_COMMIT_HASH;
export const appVersion = APP_VERSION;
export const appPackageName = APP_PACKAGE_NAME;
export const appRepositoryUrl = APP_REPOSITORY_URL;

export const api = APP_API_DOMAIN;
export const adminUrl = APP_ADMIN_URL ?? `${api}admin/`;
